// extracted by mini-css-extract-plugin
export var brand = "_2w-9";
export var compact = "_2w-6";
export var extraSmall = "_2w-7";
export var icon = "_2w-0";
export var large = "_2w-4";
export var light = "_2w-1";
export var medium = "_2w-5";
export var outline = "_2w-b";
export var primaryDark = "_2w-a";
export var primaryLight = "_2w-8";
export var primaryModern = "_2w-c";
export var success = "_2w-2";
export var successSolid = "_2w-3";